import styled from 'styled-components';

export const Content = styled.div`
  border-radius: 16px;
  border: 1px solid #2d2d32;
  background: #18181a;
  padding: 1.6rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const LinkContainer = styled.div`
  border-radius: 20px;
  border: 1px solid #313134;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.06) 0%, rgba(0, 0, 0, 0.2) 100%), #18181a;
  min-height: 4.2rem;
  font-size: 1.4rem;
  font-weight: 500;
  letter-spacing: -0.21px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0.8rem 1.2rem;
  word-break: break-all;
`;

export const Row = styled.div`
  display: flex;
  gap: 1.2rem;
`;

export const InviteButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 1rem 1.6rem;
  cursor: pointer;
  outline: none;
  border: none;
  font-size: 1.6rem;
  font-weight: 500;
  line-height: 2.2rem;
  letter-spacing: -0.43px;
  border-radius: 100px;
  background: #f8fcff;
  height: 4.2rem;
  color: #000;
`;
